import "./02_component.css"

import { useState, useRef, useEffect } from "react";

import Arrow from "../../../../assets/Images/Elements/Arrow_O1.svg"

import test from "../../../../assets/Images/Elements/M-Orange.svg"

export default function Component02() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 7;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div className="Home-Services-Main">
            <div className="Home-Services-Info">
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Website Design & Development</h2>
                        <p>
                            As a top digital marketing agency in Mumbai, Adstrate offers end-to-end website design and development services that combine creative design, responsive UX/UI, and technical excellence.
                        </p>
                        <a href="/services/website-design-and-development">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">WordPress</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">Shopify </span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">Responsive design</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">UX design</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">scalable</span>
                    </div>
                </div>
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Search Engine Optimization (SEO)</h2>
                        <p>
                            Our SEO service is designed to increase organic search visibility, attract relevant traffic, and generate qualified leads. 
                        </p>
                        <a href="/services/search-engine-optimization">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">organic traffic</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">local SEO</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">content optimization</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">keyword research</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">website SEO</span>
                    </div>
                </div>
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Content Creation</h2>
                        <p>
                            Our content creation services are designed to boost brand engagement, support marketing goals, and strengthen your online presence. 
                        </p>
                        <a href="/services/content-creation">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">video content</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">branded content</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">content production</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">content creation</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">content marketing</span>
                    </div>
                </div>
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Social Media Marketing & Management</h2>
                        <p>
                            Our social media marketing and management services help brands establish a consistent online presence, engage audiences, and drive measurable growth.
                        </p>
                        <a href="/services/social-media-marketing-and-management">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">content calendar</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">brand growth</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">community management</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">social media strategy</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">audience engagement</span>
                    </div>
                </div>
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Paid Advertising (Meta & Google Ads)</h2>
                        <p>
                            Our paid advertising services are designed to deliver measurable results and maximize ROI.
                        </p>
                        <a href="/services/paid-advertising">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">Google Ads</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">retargeting ads </span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">paid campaigns</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">ad strategy</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">Meta Ads</span>
                    </div>
                </div>
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Digital Marketing Strategy</h2>
                        <p>
                            Our digital marketing strategy service provides businesses with a clear roadmap to achieve marketing objectives and measurable growth.
                        </p>
                        <a href="/services/digital-marketing-strategy">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">brand strategy</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">growth plan</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">marketing optimization</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">business strategy</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">digital campaigns</span>
                    </div>
                </div>
                <div className={`Home-Services-Info-Cards Home-fade ${stepT === 7 ? "Home-show" : ""}`}>
                    <div className="Home-Services-Info-Cards-Main">
                        <h2>Analytics & Performance Reporting</h2>
                        <p>
                            Our analytics and performance reporting services help businesses understand how their marketing efforts are performing and identify areas for optimization.
                        </p>
                        <a href="/services/analytics-and-performance-reporting">
                            <p>View More</p>
                            <div>
                                <img src={Arrow} alt="" />
                            </div>
                        </a>
                    </div>
                    <div className="Home-Services-Info-Cards-Sub">
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">data insights</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">digital analytics</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">performance reporting</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">website analytics</span>
                        <span className="Home-Services-Info-Cards-Sub-Cards KeyTags">growth insights</span>
                    </div>
                </div>
            </div>
            <div className="Home-Services-Selector" ref={selectorRef}>
                <div className="Home-Services-Selector-Selection">
                    {[
                    "Website Design & Development",
                    "Search Engine Optimization (SEO)",
                    "Content Creation",
                    "Social Media Marketing & Management",
                    "Paid Advertising (Meta & Google Ads)",
                    "Digital Marketing Strategy",
                    "Analytics & Performance Reporting",
                    ].map((text, index) => (
                    <div
                        key={index}
                        ref={(el) => (itemRefs.current[index] = el)}
                        className={stepT === index + 1 ? "Home-Services-Selector-Card Home-active MicroLinksText" : "Home-Services-Selector-Card"}
                        onClick={() => {
                            pauseAutoSlide();
                            setStepT(index + 1);
                            scrollToItem(index);
                        }}
                    >
                        <div className="Home-Services-Selector-selection"></div>
                        <div className="Home-Services-Selector-hover"></div>
                        <p>{text}</p>
                    </div>
                    ))}
                </div>
                <div className="Home-Services-Selector-Img">
                    <img src={test} alt="" />
                </div>
            </div>
        </div>
    );
}